<template>
  <section id="vote_landing_page">

    <h3 class="section_title">Voting</h3>
    
    <!-- REMOVE FOR PRODUCTION -->
    <!-- <dev-period-simulator
    v-if="env == 'development'"
    ></dev-period-simulator> -->
    <!-- END REMOVE FOR PRODUCTION -->

   
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          
          <!-- EVENT NOT STARTED -->
          <intro-not-started
          v-if="instance_period == 'Event not started' || instance_period == 'Nomination Period' || instance_period == 'Nomination Intermission'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          ></intro-not-started>

          <!-- VOTING PERIOD -->
          <intro-voting-period
          v-if="instance_period == 'Voting Period'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          :is_logged_in="is_logged_in"
          ></intro-voting-period>

          <!-- VOTING INTERMISSION -->
          <intro-voting-intermission
          v-if="instance_period == 'Voting Intermission'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          ></intro-voting-intermission>

          <!-- WINNERS PERIOD AND BEYOND -->
          <intro-winners-period
          v-if="instance_period == 'Winners Period' || instance_period == 'Event has ended'"
          :vote_start_date="vote_period_data.start"
          :tz_offset="timezone_offset"
          ></intro-winners-period>
          
        </div>
      </div>

    </div>

    <div class="login_category_container"
    v-if="instance_period == 'Voting Period'"
    >
      <trans-bounce>

        <!-- LOGIN PROMPT FOR NON-LOGGED-IN USERS -->
        <login-prompt
        v-if="!is_logged_in"
        ></login-prompt>

        <!-- SUPER CATEGORY LIST -->
        <super-category-list
        v-else
        list_type="voting"
        ></super-category-list>

      </trans-bounce>
    </div>

    <div class="container">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
          
          <h4>
            Here's some other great stuff from Dayton.com:
          </h4>
          <dcom-latest-stories-list></dcom-latest-stories-list>

        </div>
      </div>
    </div>

  </section>
</template>

<script>
import SuperCategoryList from '@/features/category/super_category_contest_list.vue';
import LoginPrompt from '@/features/login/login_prompt.vue';
import TransBounce from '@/components/transitions/trans_bounce_inL_outR.vue';
import IntroNotStarted from '@/features/vote/intros/vote_intro_event_not_started.vue';
import IntroVotingPeriod from '@/features/vote/intros/vote_intro_voting_period.vue';
import IntroVotingIntermission from '@/features/vote/intros/vote_intro_voting_intermission.vue';
import IntroWinnersPeriod from '@/features/vote/intros/vote_intro_winners_period.vue';
import DevPeriodSimulator from '@/components/dev_tools/dev_period_simulator.vue';
import DcomLatestStoriesList from '@/features/cms_content/dcom_latest_stories_list'

export default {
  name: 'vote_landing_page',
  data () {
    return {
      show_contest_index: 0,
      vote_complete: false,
      voting_period_started: false, // NEED TO MAKE THIS A CALCULATION FROM STORE
      nomination_period_started: true,
      env: this.$root.state.env
    }
  },
  created() {
    // this.contest_list = this.$root.store.contests.get_master_contest_list();
  },
  mounted() {
    document.dispatchEvent(new Event('prerender-trigger'));
    this.determine_chartbeat();
  },
  watch: {
    
  },
  computed: {
    instance_period: {
      get: function() {
        return this.$root.store.instances.get_current_active_instance_period();
      }
    },
    is_logged_in: function() {
      return this.$root.store.session.check_login_status();
    },
    timezone_offset: function() {
      return this.$root.store.instances.get_current_timezone_offset();
    },
    vote_period_data: function() {
      return this.$root.store.instances.get_specific_instance_period('Voting Period');
    }
  },
  methods: {
    goto_path: function(path_name) {
      this.$root.store.goto_path(path_name);
    },
    run_chartbeat: function() {
      window.updateChartbeat(document.title, window.location.pathname);
    },
    determine_chartbeat: function() {
      let vm = this;
      let page_title = document.title;

      if(page_title.indexOf(vm.$metaInfo.title) == 0) {
        vm.run_chartbeat();
      }
      else {
        setTimeout(function() {
          vm.determine_chartbeat();
        }, 500);
      }
    }
  },
  metaInfo() {
    return {
      title: 'Voting Information',
      titleTemplate: '%s | Best of Dayton 2019',
      meta: [
        {
          name: 'description',
          vmid: 'description',
          content: 'Find out how to vote for your favorite people, places, food, events, and more in the 2019 Best of Dayton contest.'
        },
        {
          property: 'og:image',
          content: 'https://www.dayton.com/rf/image_large/Pub/p10/Dayton/2019/11/08/Images/DDC_BestofDayton_LeadRelatedObject_169.jpg'
        }
      ]
    }
  },
  components: {
    SuperCategoryList,
    LoginPrompt,
    TransBounce,
    IntroNotStarted,
    IntroVotingPeriod,
    IntroVotingIntermission,
    IntroWinnersPeriod,
    DevPeriodSimulator,
    DcomLatestStoriesList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/pages/VoteLandingPage.vue